module.exports = __webpack_public_path__ + "static/media/burger_jeff.166b7262.jpg";